import { ROLE_LIST } from "./global";

export const PAGE = {
  index: 'worklist',
  login: {
    id: 'login',
    path: '/login',
    name: 'Login',
    title: 'Login',
    nav: false,
    icon: null,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  worklist: {
    id: 'worklist',
    path: '/worklist',
    name: '工作列表',
    title: '工作列表',
    nav: false,
    icon: null,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  creatework: {
    id: 'creatework',
    path: '/worklist/create',
    name: '建立工作',
    title: '建立工作',
    nav: false,
    icon: null,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  accountlist: {
    id: 'accountlist',
    path: '/accountlist',
    name: '工作列表',
    title: '工作列表',
    nav: false,
    icon: null,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  creatework_account: {
    id: 'creatework_account',
    path: '/accountlist/create',
    name: '建立工作',
    title: '建立工作',
    nav: false,
    icon: null,
    allow: [
      ROLE_LIST.root.code,
      ROLE_LIST.admin.code,
      ROLE_LIST.editor.code,
      ROLE_LIST.viewer.code
    ]
  },
  privacy: {
    id: 'privacy',
    path: '/privacy',
    name: '隱私權政策',
    title: '隱私權政策',
    nav: false,
    icon: null,
    allow: null
  },
  userTerm: {
    id: 'userTerms',
    path: '/user-terms',
    name: '服務條款',
    title: '服務條款',
    nav: false,
    icon: null,
    allow: null
  },
}